import React, { useState } from 'react';
import { Table } from "react-bootstrap"
import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import getAllForms from '../../api/getAllForms';
import FormModal from './FormModal';
import { setSelectedForm } from '../../redux/selectedFormSlice';
import validateForm from '../../api/validateForm';
import Loader from '../../pages/utilities/loader';
import { Modal, Input } from 'antd';
import deleteForm from '../../api/deleteForm';


const EditForm = () => {
    const selectedProject = useSelector(state => state.selectedProject);
    const { isLoading, data: forms, refetch } = useQuery("getAllForms", () => getAllForms(selectedProject.name))
    const [showModal, setShowModal] = useState(false);
    const [formName, setFormName] = useState('');
    const [visible, setVisible] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const selectedForm = useSelector(state => state.selectedForm)
    const handleClose = () => setShowModal(false);
    const history = useHistory()
    const dispatch = useDispatch()

    const handleViewClick = (form) => {
        dispatch(setSelectedForm(form))
        setShowModal(true);
    }

    const handleEditClick = (form) => {
        dispatch(setSelectedForm(form))
        history.push("/form-edit")
    }

    const handleValidateForm = async (form) => {
        await validateForm(selectedProject.name, form)
        refetch();
    }

    const handleRemoveForm = async (form) => {
        setVisible(true);
        setFormName(form)
    }

    const showModale = () => setVisible(true);
    const handleOk = async () => {
        await deleteForm(selectedProject.name, formName)
        refetch();
        setVisible(false);
    };
    const handleCancel = () => {
        setVisible(false)
        setInputValue('');
    };

    if (isLoading) return <><Loader /></>

    return (
        <>
            <FormModal selectedForm={selectedForm} show={showModal} handleClose={handleClose} />
            <div className="recent-activities form-documents">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="border-0 m-0">Editer un formulaire</h3>
                </div>
                <Table>
                    <thead>
                        <tr>
                            <th>Nom</th>
                            <th>Status</th>
                            <th className="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {forms.data.map((form) => {
                            const { form_name, form_status } = form
                            return <tr>
                                <td>{form_name}</td>
                                <td>{form_status}</td>
                                <td className="text-center">
                                    <button onClick={() => handleViewClick(form)} className="view-btn" title="view"><i className="ti-eye"></i></button>
                                    <button className="edit-btn" title="edit" onClick={() => handleEditClick(form)}><i className="ti-pencil-alt"></i></button>
                                    <button className="validate-btn" onClick={() => handleValidateForm(form_name)} title="validate"><i className="ti-check-box"></i></button>
                                    <button className="remove-btn" onClick={() => handleRemoveForm(form_name)} title="delete"><i className="ti-trash"></i></button>
                                </td>
                            </tr>
                        })}
                    </tbody>
                </Table>

                <Modal
                    visible={visible}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    okText="Oui"
                    cancelText="Non"
                    okButtonProps={{
                        style: {
                            backgroundColor: inputValue.trim() === `supprimer ${formName.toLowerCase()}` ? '#A31621' : '#aebdb2',
                            borderColor: inputValue.trim() === `supprimer ${formName.toLowerCase()}` ? '#A31621' : '#aebdb2',
                        },
                        disabled: inputValue.trim() !== `supprimer ${formName.toLowerCase()}`,
                    }}
                >
                    <div className='text-black'>
                        <p className='text-black'>Êtes-vous sûr de vouloir supprimer le formulaire ?</p>
                        <p className='text-black'>Cette action est irréversible.</p>

                        <div className='mt-4'>
                            <p className='mb-1 text-black'>Pour confirmer écrivez: <b>supprimer {formName.toLowerCase()}</b></p>
                            <Input
                                type="text"
                                className="form-control input-1"
                                required
                                onChange={(e) => setInputValue(e.target.value)}
                                value={inputValue}
                            />
                        </div>
                    </div>
                </Modal>
            </div>
        </>
    );
}

export default EditForm;
